import React, {ReactElement} from 'react';

import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  Bar
} from 'recharts';

import Spinner from '../Spinner';
import TableEmptyState from './TableEmptyState';

type RenderShapeProps = {
  fill: string;
  width: number;
  height: number;
  x: number;
  y: number;
};

const PageViewChart = ({
  chartStyles,
  data,
  loading,
  height
}: {
  chartStyles: any;
  data: any;
  loading: boolean;
  height?: string;
}): ReactElement => {
  const RenderBarShape = ({
    fill,
    x,
    y,
    width,
    height: _height
  }: RenderShapeProps): React.ReactElement => {
    return (
      <svg fill={fill}>
        <rect width={width} height={_height} x={x} y={y} rx={2} stroke="none" />
      </svg>
    );
  };

  const renderTableContents = () => {
    if (loading) {
      return <Spinner />;
    }
    if (!data?.length) {
      return <TableEmptyState />;
    }
    return (
      <ResponsiveContainer width="99%">
        <BarChart data={data} barGap={0}>
          <XAxis dataKey="date" />
          <YAxis dataKey="pageviews" hide />
          <Tooltip animationDuration={chartStyles.animationDuration} />
          <Bar
            animationDuration={chartStyles.animationDuration}
            dataKey="pageviews"
            name="Page views"
            minPointSize={3}
            fill="#5ccfc2"
            shape={RenderBarShape}
          />
        </BarChart>
      </ResponsiveContainer>
    );
  };

  return (
    <div className="content-card admin--storeTraffic" style={{height}}>
      <small>Page views </small>
      <div className="center-content">{renderTableContents()}</div>
    </div>
  );
};

PageViewChart.defaultProps = {
  height: '100%'
};

export default PageViewChart;
